import { NotificationWorkflow } from './notification-workflow';
import {
  NOTIFICATION_WORKFLOW_CATEGORY_ORDER,
  NotificationWorkflowCategory,
} from './notification-workflow-category';

export type NotificationWorkflowCategoryGroup = {
  category: NotificationWorkflowCategory;
  workflows: NotificationWorkflow[];
};

/**
 * Groups registered workflows by Knock category, preserving category display order.
 * Categories with no registered workflows are omitted (e.g. future `fragments`).
 */
export function groupNotificationWorkflowsByCategory(
  workflows: readonly NotificationWorkflow[],
): NotificationWorkflowCategoryGroup[] {
  return NOTIFICATION_WORKFLOW_CATEGORY_ORDER.flatMap((category) => {
    const groupWorkflows = workflows.filter((workflow) => workflow.category === category);
    if (groupWorkflows.length === 0) {
      return [];
    }
    return [{ category, workflows: groupWorkflows }];
  });
}
